import { render, staticRenderFns } from "./RegisterSchool.vue?vue&type=template&id=3a824d8f&scoped=true&"
import script from "./RegisterSchool.vue?vue&type=script&lang=js&"
export * from "./RegisterSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a824d8f",
  null
  
)

export default component.exports